import React from 'react';
import MobileService from 'services/mobile';
import styles from './index.module.scss';

interface ISwitcherProps {
  onChange(checked: boolean): void;
  offName: string;
  onName: string;
  checked: boolean;
}

const Switcher: React.FC<ISwitcherProps> = ({
  onChange,
  offName,
  onName,
  checked,
}) => {
  return (
    <div
      role="presentation"
      onClick={() => onChange(!checked)}
      className={`${styles.container} ${
        MobileService.isMobile ? styles.tablet : ''
      }`}
    >
      <input
        readOnly
        checked={checked}
        type="checkbox"
        id="toggle-button"
        className={`${styles.toggleButton} ${
          MobileService.isMobile ? styles.tablet : ''
        }`}
      />
      <div style={!checked ? { color: '#fff' } : {}} className={styles.linear}>
        {offName}
      </div>
      <div style={checked ? { color: '#fff' } : {}} className={styles.static}>
        {onName}
      </div>
    </div>
  );
};

export default Switcher;
